import React from 'react';

class Footer extends React.Component {
  render () {
    return (
      <div className="col-md-12">
        <hr/>
        <div className="footer-content">About | Support | Privacy Terms</div>
        <br/>
      </div>
      )
  }
}

export default Footer;